export class BravoProxyConfig {
    static websocketHost = 'wss://ws.bravo.cloud';
    static configBackend = 'https://config.bravo.cloud';
    static apiBackend = 'https://backend.bravo.cloud';
}
